<template>
  <div class="change-subscription-form">
    <fieldset v-if="!showConfirmation && !showError && !showSuccess">
      <div class="row">
        <div class="column column-100">
          <div class="message" v-html="labels['changeSubscriptionEmailText']"></div>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <input type="email" name="email" v-validate="'required|email'" @input="updateEmail" :placeholder="labels['email']" :value="email">
          <small v-show="errors.has('email')" class="help error">{{ errors.first('email') }}</small>
        </div>
      </div>
      <div class="row">
        <div class="column column-50">
          <input type="number" name="old_sum" v-validate="'required|numeric'" @input="updateOldSum" :placeholder="labels['changeSubscriptionOldSumPlaceholder']" :value="oldSum">
          <small v-show="errors.has('oldSum')" class="help error">{{ errors.first('oldSum') }}</small>
        </div>
        <div class="column column-50">
          <input type="number" name="new_sum" v-validate="'required|numeric'" @input="updateSum" :placeholder="labels['changeSubscriptionSumPlaceholder']" :value="newSum">
          <small v-show="errors.has('newSum')" class="help error">{{ errors.first('newSum') }}</small>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <button class="button button-outline donate" @click="changeSubscription">{{ action }}</button>
        </div>
      </div>
    </fieldset>
    <div v-if="showError" class="row">
      <div class="column column-100">
        <div class="message" v-html="labels['changeSubscriptionError']"></div>
      </div>
    </div>
    <div v-if="showConfirmation" class="row">
      <div class="column column-100">
        <div class="message" v-html="labels['changeSubscriptionConfirmation'](email)"></div>
      </div>
    </div>
    <div v-if="showSuccess" class="row">
      <div class="column column-100">
        <div class="message" v-html="labels['changeSubscriptionSuccess']"></div>
      </div>
    </div>
    <Overlay v-if="showOverlay" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  computed: mapState({
    email: state => state.donation.email,
    newSum: state => state.newSum,
    oldSum: state => state.oldSum,
    lang: state => state.language,
    labels: state => LABELS[state.language],
    action: state => LABELS[state.language]['changeSubscription'],
    showConfirmation: state => state.step === 'confirmation',
    showError: state => state.step === 'error',
    showSuccess: state => state.step === 'success',
    showOverlay: state => (state.step === 'precheckout' || state.step === 'checkout') && state.checkoutType !== 'popup'
  }),
  inject: ['$validator'],
  methods: {
    updateEmail (e) {
      const prop = 'email'
      const value = e.target.value
      const change = { prop, value }
      this.$store.commit('updateDonation', change)
    },
    updateSum (e) {
      const value = e.target.value
      const change = {
        'newSum': value
      }
      this.$store.commit('updateState', change)
    },
    updateOldSum (e) {
      const value = e.target.value
      const change = {
        'oldSum': value
      }
      this.$store.commit('updateState', change)
    },
    changeSubscription () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('changeSubscription')
        }
      })
    }
  },
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-donation-form .change-subscription-form {
    font-size: small;
    border-bottom: 1px solid #aaa;
    padding-bottom: 10px;
  }
  .oi-donation-form .change-subscription-form .details {
    margin-bottom: 20px;
  }
  .oi-donation-form .change-subscription-form .message {
    margin: 10px 0;
  }
  .oi-donation-form .change-subscription-form small.help {
    margin: 0 0 5px;
    position: relative;
    top: -5px;
  }
</style>
